import React from 'react';
import PaywallRowItem from '../row-item';
import PaywallGroupHeader from './components/group-header';
const defaultAvailablePlans = [];

const PaywallBody = ({
  data,
  isLoading = false,
  highlightedElementId = '',
  onTooltipHover = Function.prototype,
  groupTitle = '',
  availablePlans = defaultAvailablePlans,
}) => {
  const withHeader = groupTitle || !!availablePlans.length;

  return (
    <React.Fragment>
      {withHeader && <PaywallGroupHeader groupTitle={groupTitle} availablePlans={availablePlans} />}
      {data.map(({ id, ...rowData }) => (
        <PaywallRowItem
          {...rowData}
          loading={isLoading}
          highlightedElementId={highlightedElementId}
          key={id}
          onTooltipHover={() => onTooltipHover(id)}
        />
      ))}
    </React.Fragment>
  );
};

export default PaywallBody;
